<template>
  <div class="columns account-info-wrapper">

    <div class="column img-column">
      <img width="auto" src="@/assets/carrier-perks-imgs/koniglogo.jpg"/>
    </div>
    <div class="column is-two-thirds content">
      <p>
        Truckl partners with Konig Transportation to provide a comprehensive suite of back office services raging from insurance products to tax preparation and authorities.
      </p>
      <p>
        Insurance providers include Progressive, Canal, Berkshire Hathaway, CRC and SunForest.
      </p>
      <p>
        Back office support:
      </p>
      <div class="columns">
        <ul class="column is-one-quarter">
          <li>Tax</li>
          <li>Accounting</li>
          <li>Bookkeeping</li>
          <li>Authority Set-ups</li>
          <li>IFTA & IRP</li>
          <li>Payroll</li>
        </ul>
        <ul class="column">
          <li>Permits</li>
          <li>HUT (NY,KY,NM & OR)</li>
          <li>2290 FILING</li>
          <li>Incorporating/ any state</li>
          <li>Drug Consortium</li>
        </ul>
      </div>

      <p>
        To take advantage of Konig Transportation services, please contact the company at (915) 781-4456 or email <a href="mailto:Omar.S@Konigtransportation.com">Omar.S@Konigtransportation.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import AccountInfo from '../AccountInfo'
import CarrierInfo from '../CarrierInfo'

export default {
  name: 'TrucklBackOffice',

  components: {
    AccountInfo,
    CarrierInfo
  }
}
</script>

<style scoped lang="scss">
@import 'styles';

.columns .columns {
  height: auto;
}
</style>
